<template>
  <div class="container">
    <h1>🎵 Lofi Музыка</h1>
    <button @click="startMusic" :disabled="!isReady">
      {{ isReady ? '▶️ Включить музыку' : '⏳ Загрузка...' }}
    </button>
    <button v-if="isPlaying" @click="pauseMusic" class="pause-btn">
      ⏸️ Пауза
    </button>
    <div class="volume-control" v-if="isReady">
      <label>Громкость: {{ volume }}%</label>
      <input
        type="range"
        min="0"
        max="100"
        v-model="volume"
        @input="setVolume"
      />
    </div>
    <!-- YouTube плеер -->
    <div id="player" style="display: none;"></div>
  </div>
</template>

<script setup>
import { onMounted, ref, nextTick } from 'vue'

const isReady = ref(false)
const isPlaying = ref(false)
const volume = ref(50)
let player = null

// YouTube video ID для lofi музыки
const videoId = 'tNkZsRW7h2c'

function onYouTubeIframeAPIReady() {
  nextTick(() => {
    player = new window.YT.Player('player', {
      height: '0',
      width: '0',
      videoId: videoId,
      playerVars: {
        autoplay: 0,
        controls: 0,
        rel: 0,
        modestbranding: 1,
        loop: 1,
        playlist: videoId // Для зацикливания
      },
      events: {
        onReady: (event) => {
          isReady.value = true
          console.log('YouTube плеер готов')
          // Устанавливаем начальную громкость
          event.target.setVolume(volume.value)
        },
        onStateChange: (event) => {
          if (event.data === window.YT.PlayerState.PLAYING) {
            isPlaying.value = true
          } else if (event.data === window.YT.PlayerState.PAUSED) {
            isPlaying.value = false
          }
        }
      }
    })
  })
}

function loadYouTubeAPI() {
  // Проверяем, загружен ли уже API
  if (window.YT && window.YT.Player) {
    onYouTubeIframeAPIReady()
    return
  }

  // Создаем глобальную функцию для callback
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady

  // Загружаем YouTube API
  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

function startMusic() {
  if (player && isReady.value) {
    try {
      player.playVideo()
      console.log('Воспроизведение начато')
    } catch (error) {
      console.error('Ошибка воспроизведения:', error)
    }
  }
}

function pauseMusic() {
  if (player && isReady.value) {
    player.pauseVideo()
  }
}

function setVolume() {
  if (player && isReady.value) {
    player.setVolume(volume.value)
  }
}

onMounted(() => {
  loadYouTubeAPI()
})
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  font-family: sans-serif;
  color: #fff;
  background: linear-gradient(135deg, #1e1e2f, #2e2e4d);
  min-height: 100vh;
  justify-content: center;
  padding: 20px;
}

h1 {
  margin-bottom: 30px;
  font-size: 2.5rem;
}

button {
  background: #444;
  border: none;
  color: white;
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  margin: 10px;
  transition: background 0.3s;
}

button:hover:not(:disabled) {
  background: #555;
}

button:disabled {
  background: #888;
  cursor: not-allowed;
}

.pause-btn {
  background: #e74c3c;
}

.pause-btn:hover {
  background: #c0392b;
}

.volume-control {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.volume-control label {
  font-size: 14px;
  color: #ccc;
}

.volume-control input[type="range"] {
  width: 200px;
  height: 5px;
  border-radius: 5px;
  background: #444;
  outline: none;
}

.volume-control input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}

.volume-control input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  border: none;
}
</style>